import { z } from 'zod'

/**
 * Alert priority level
 * 1 = High (red), 2 = Medium (yellow), 3 = Low (blue)
 */
export type AlertPriority = 1 | 2 | 3

/**
 * Alert status indicating whether it's a normal state or alarm
 */
export type AlertStatus = 'Normal' | 'Alarm'

/**
 * Confidence level for probable causes
 */
export type CauseConfidence = 'high' | 'medium' | 'low'

/**
 * A probable cause for an alert
 */
export interface ProbableCause {
  title: string
  description: string
  confidence: CauseConfidence
}

/**
 * Asset information linked to an alert
 */
export interface AlertAssetInfo {
  asset_id: string
  asset_name: string
  site: string
  area: string
}

/**
 * Search schema for alerts page URL parameters
 */
export const alertsPageSearchSchema = z.object({
  page: z.number().optional().default(0),
  pageSize: z.number().optional().default(25),
  selectedAlertId: z.string().optional(),
  // Table filter columns
  'data.priority': z.number().optional(),
  'data.timestamp': z
    .tuple([z.string().nullable(), z.string().nullable()])
    .optional(),
  'data.acknowledged': z.array(z.string()).optional(),
  'data.status': z.string().optional(),
  'data.area': z.string().optional(),
  'data.name': z.string().optional(),
  'data.description': z.string().optional(),
  'data.alerted_value': z.number().optional(),
  'data.setpoint': z.number().optional(),
  'data.unit': z.string().optional(),
})
